<div
    class="navigation-bar"
    [ngClass]="{
        'navigation-bar--on-mobile': showOnMobile,
        'navigation-bar--on-mobile-hide': env.HEADER?.HIDE_HORIZONTAL_MENU
    }">
    <ridango-page-content-wrapper>
        <ng-content></ng-content>
    </ridango-page-content-wrapper>
</div>
